import config from '../config';
import {areSchemefulSameSite} from './schemefulSameSite';

/** For fetchWithRetry — not a React hook. */
export function isFetchCorsWithCredentialsEnabled(): boolean {
  return config.FETCH_SAMESITE_CORS_WITH_CREDS;
}

/**
 * Returns the `RequestCredentials` value to use when fetching a given media
 * URL, or `undefined` if credentials should not be sent.
 *
 * Credentials are included only when the deployment toggle is on, the fetch is
 * cross-origin, and page and request URLs are schemeful same-site (eTLD+1).
 */
export function resolveMediaFetchCredentials(
  url: string
): RequestCredentials | undefined {
  if (!isFetchCorsWithCredentialsEnabled()) {
    return undefined;
  }

  let requestUrl: URL;
  let pageUrl: URL;
  try {
    requestUrl = new URL(url);
    pageUrl = new URL(window.location.href);
  } catch {
    return undefined;
  }

  if (requestUrl.origin === pageUrl.origin) {
    return undefined;
  }

  if (!areSchemefulSameSite(requestUrl, pageUrl)) {
    return undefined;
  }

  return 'include';
}
